import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import ProjectUtils from "../../../../utils/project-utils.js";
import {MaskDefault} from "../../../../utils/mask.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {
    const sourceOptions = [
        { value: "EXTERN-MJ", label: "Córtex" },
        { value: "EXTERN-OTHERS", label: "Outros" },
    ];

    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDateTime
                    id="dtStart"
                    label="Data/hora inicial *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtStart ? new Date(filters.dtStart) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                    onBlur={(e) => {
                        if (!e.target.value?.trim()) {
                            setFilters(prev => ({ ...prev, dtStart: new Date() }))
                        };
                    }}
                />
                <InputDateTime
                    id="dtEnd"
                    label="Data/hora final *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                    onBlur={(e) => {
                        if (!e.target.value?.trim()) {
                            setFilters(prev => ({ ...prev, dtEnd: new Date() }))
                        };
                    }}
                />
                <InputForm
                    id="plateOrCpf"
                    label="Placa ou CPF"
                    classNameWrapper="w-full"
                    value={filters.plateOrCpf}
                    mask={MaskDefault.plateNoRestrict}
                    onChange={({ target }) => setFilters(prev => ({ ...prev, plateOrCpf: target?.value.toUpperCase() }))}
                />
                <SelectComponent
                    id="source"
                    label="Origem"
                    classNameWrapper="w-full"
                    isMulti={true}
                    wrapValues={true}
                    options={sourceOptions}
                    value={filters.source}
                    onChange={(value) => setFilters(prev => ({ ...prev, source: value }))}
                />
            </form>
        </div>
    )
}